// extracted by mini-css-extract-plugin
export default {"container":"AppTile_container__Fh2MM","title":"AppTile_title__6tg6M"};